/* Add visible, accessible permalinks to article headings. */
(function () {
    const markers = {
        H2: '#',
        H3: '##',
        H4: '###',
    };

    document.querySelectorAll('.gh-content > h2[id], .gh-content > h3[id], .gh-content > h4[id]').forEach(function (heading) {
        if (heading.querySelector(':scope > .gh-heading-anchor')) return;

        const anchor = document.createElement('a');
        const headingText = heading.textContent.trim();

        anchor.className = 'gh-heading-anchor';
        anchor.href = `#${heading.id}`;
        anchor.textContent = markers[heading.tagName];
        anchor.setAttribute('aria-label', `Link to ${headingText}`);

        heading.prepend(anchor);
    });
})();
